import { readFileSync } from 'fs';
import { Command } from 'commander';
import { type OutputFormat } from './output.js';

export function parseData(data: string): Record<string, unknown> {
  if (data.startsWith('@')) {
    const content = readFileSync(data.slice(1), 'utf-8');
    return JSON.parse(content) as Record<string, unknown>;
  }
  return JSON.parse(data) as Record<string, unknown>;
}

/** The public MCP connection URL for a Factory toolset slug. */
export function mcpToolsetUrl(slug: string): string {
  return `https://mcp.rekor.pro/t/${slug}/mcp`;
}

export function getBase(cmd: Command): string {
  // Walk up the command chain to find --base on the root program
  let current: Command | null = cmd;
  while (current) {
    const ws = current.opts().base as string | undefined;
    if (ws) return ws;
    current = current.parent;
  }
  console.error('Error: --base is required');
  return process.exit(1);
}

export function getFormat(cmd: Command): OutputFormat {
  // The global --output / --json flags live only on the root program. Commander
  // routes them to the root regardless of nesting depth or whether they appear
  // before or after the subcommand, so we resolve from the root rather than a
  // fixed parent.parent walk (which missed the root on 4-level commands like
  // `admin report list`). Reading the root also avoids picking up a subcommand's
  // own same-named --output (e.g. `providers export --output <file>`).
  let root: Command = cmd;
  while (root.parent) root = root.parent;
  const opts = root.opts();
  // Compare against 'json' rather than casting opts.output through, so an
  // unrecognized --output value falls back to 'table' instead of a bogus format.
  return opts.json || opts.output === 'json' ? 'json' : 'table';
}
